import { ClockIcon } from '@/components/icons/clock'
import { cn } from '@/utils/cn'

interface Props {
  description: string
  className?: string
}

export const TransactionSupportComingSoonPanel = ({ description, className }: Props) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center gap-2 rounded-2xl border bg-surface p-4 text-center',
      className
    )}
  >
    <ClockIcon size={48} className="shrink-0 text-accent" />
    <div className="flex w-full flex-col gap-2 text-center">
      <p className="font-medium text-heading-foreground text-xl">Transaction support coming soon</p>
      <p className="text-sm">{description}</p>
    </div>
  </div>
)
